import { render } from "./PBuyCoins.vue?vue&type=template&id=6f95103f"
import script from "./PBuyCoins.vue?vue&type=script&lang=js"
export * from "./PBuyCoins.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__